/* July 2026: collection-card swatches.
   1) "more colors" overflow circle -> navigate to product page (capture phase; product-card stops propagation).
   2) Neutralize leftover Globo/SPF swatch-overflow code (the app was removed): the ProductCard.onElemResize
      method injected a "show more" toggle / +N circle that expanded rows on mobile and conflicted with the
      theme own overflow circle. We no-op it and remove any elements it created. */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var t = e.target.closest('.collection-swatches__overflow[data-product-url]');
    if (!t) return;
    var url = t.getAttribute('data-product-url');
    if (!url) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
  }, true);

  function stripGlobo() {
    var junk = document.querySelectorAll(
      '.card__variant-list-show-more-toggle, .more-swatches, .card__variant-list .spf-product__swatch'
    );
    Array.prototype.forEach.call(junk, function (el) { el.remove(); });
  }
  function neutralize() {
    try {
      var PC = window.customElements && customElements.get('product-card');
      if (PC && PC.prototype && typeof PC.prototype.onElemResize === 'function') {
        PC.prototype.onElemResize = function () {};
      }
    } catch (err) {}
    stripGlobo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', neutralize);
  } else {
    neutralize();
  }
  document.addEventListener('products:loaded', stripGlobo);
})();
